import React, { Component } from 'react';
import voca from 'voca';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { bindActionCreators } from 'redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { drapcodeIcon, iconForField } from '../../common/custom/icon-library';
import CustomSelect from '../../common/formElements/CustomSelect';
import CustomLoader from '../common/CustomLoader';
import { ALPHA, BETA, PREVIEW, PRODUCTION } from '../../common/utils/environments';
import { Environment } from './Environment';
import { validateConstantType, validateName } from '../../common/utils/validate';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import { ENVIRONMENT } from 'drapcode-constant';
import ParentContentCard from '../common/ParentContentCard';
import ParentDocCard from '../common/ParentDocCard';
import { isProjectReadOnly } from '../../common/utils/api_utils';
const environmentSchema = { name: '', envType: '' };
export class EnvironmentSetting extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    isOpenModal: false,
    envTypes: [PREVIEW, PRODUCTION, BETA, ALPHA],
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.getPermissionFlags({ projectId });
  }

  toggle = () => {
    this.setState({ isOpenModal: !this.state.isOpenModal });
  };

  handleSubmit = async (values) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const { addEnvironmentInProject } = actions;
    await addEnvironmentInProject({ ...values, projectId, version });
  };

  deleteEnvironment = async (uuid) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const { removeEnvironmentFromProject } = actions;
    await removeEnvironmentFromProject({ uuid, version, projectId });
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  generateProjectEnvURL = (envType, domainName, seoName) => {
    let url = '';
    const exchangeSurfaceUrl = process.env.REACT_APP_EXCHANGE;
    if (envType === ALPHA) {
      url = `${seoName}.uat.${exchangeSurfaceUrl}`;
    } else if (envType === BETA) {
      url = `${seoName}.sandbox.${exchangeSurfaceUrl}`;
    } else if (envType === PRODUCTION) {
      if (domainName) {
        url = domainName;
      } else {
        url = `${seoName}.${exchangeSurfaceUrl}`;
      }
    }
    return (
      <a className="icon-link" href={`https://${url}`} target="_blank">
        {url}
      </a>
    );
  };

  showAddEnvironment = () => {
    const { appSetting, match } = this.props;
    const { projectId } = match.params;
    const { addEnvironmentInProjectPending, projectDetail } = appSetting;
    if (!projectDetail) {
      return '';
    }
    let { environments, projectType } = projectDetail;
    environments = environments || [];
    //TODO: Need to fix this to allow PAID_4 etc
    //Also check for other places
    const upgrade = !['PAID_2', 'PAID_3'].includes(projectType);
    let options = this.state.envTypes.filter((e) => {
      if (!environments.map((env) => env.envType).includes(e)) return e;
    });

    if (!options || options.length === 0) {
      return '';
    }

    options = options.map((opt) => ({ value: opt, label: voca.titleCase(opt) }));
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <>
        <div className="text-right">
          <button
            type="button"
            className="btn btn-theme-submit btn-md"
            onClick={isReadOnly ? undefined : this.toggle}
            style={{ bottom: '70px' }}
            disabled={isReadOnly}
            title={isReadOnly ? 'Read-Only Mode' : 'Add Environment'}
          >
            <i className={`wb webconnect-plus`}></i> Add Environment
          </button>
        </div>
        <Modal isOpen={this.state.isOpenModal} toggle={this.toggle} backdrop="static">
          <ModalHeader toggle={this.toggle} className="border-bottom">
            {upgrade ? (
              <strong>Upgrade Project Plan</strong>
            ) : (
              <strong>Create Project Environment</strong>
            )}
          </ModalHeader>
          <ModalBody>
            {upgrade ? (
              <div>
                Upgrade to Professional Plan or Growth Plan to download the source code of this
                project.
              </div>
            ) : (
              <div className="row pt-2 pb-2">
                <Formik
                  initialValues={environmentSchema}
                  onSubmit={(values, { setSubmitting, resetForm }) => {
                    !isReadOnly && this.handleSubmit(values);
                    setSubmitting(false);
                    this.toggle();
                    resetForm();
                  }}
                >
                  {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
                    return (
                      <Form className="form-horizontal">
                        <div className="row mx-auto">
                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                            <div className="form-group">
                              <div className="input-group">
                                <div className="input-group-prepend" title="Method Name">
                                  <span className="input-group-text">
                                    <i className={`wb ${iconForField('text')}`}></i>
                                    <span className="required"> *</span>
                                  </span>
                                </div>
                                <Field
                                  type="text"
                                  name="name"
                                  className="form-control form-control-sm"
                                  placeholder="Name of Environment"
                                  validate={validateName}
                                />
                                <ErrorMessage name="name">
                                  {(msg) => <p className="text-error">{msg}</p>}
                                </ErrorMessage>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                            <div className="form-group">
                              <div className="input-group">
                                <div className="input-group-prepend" title="Constant Type">
                                  <span className="input-group-text">
                                    <i className={`wb ${iconForField('select')}`}></i>
                                    <span className="required"> *</span>
                                  </span>
                                </div>
                                <Field
                                  as={CustomSelect}
                                  name="envType"
                                  isMulti={false}
                                  options={options}
                                  onChange={setFieldValue}
                                  onBlur={setFieldTouched}
                                  onChangeValue={this.handleChange}
                                  validate={validateConstantType}
                                  placeholder="Environment Type"
                                />
                                <small className="field-details">Type of Environment</small>
                                <ErrorMessage name="constantType">
                                  {(msg) => <p className="pl-0 ml-5 mt-5 text-error">{msg}</p>}
                                </ErrorMessage>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12 col-lg-12 mt-2 text-right">
                            <button
                              type="button"
                              className="btn btn-default btn-md"
                              onClick={() => resetForm()}
                            >
                              <span>
                                <i className={`wb ${drapcodeIcon('clear')}`}></i>&nbsp;Cancel
                              </span>
                            </button>
                            &nbsp;
                            <button
                              type="submit"
                              className="btn btn-theme-submit btn-md"
                              disabled={
                                addEnvironmentInProjectPending || isReadOnly ? 'disabled' : ''
                              }
                              title={isReadOnly ? 'Read-Only Mode' : 'Create Environment'}
                            >
                              <i className="wb webconnect-plus"></i>&nbsp; Create
                              <CustomLoader loading={addEnvironmentInProjectPending} />
                            </button>
                          </div>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            )}
          </ModalBody>
          {upgrade && (
            <ModalFooter className="d-flex justify-content-center">
              <a
                href={`${process.env.REACT_APP_ORGANIZATION}${projectId}/project-detail`}
                className="btn btn-theme-submit"
                title="Upgrade Plan"
                target="_blank"
              >
                <i className="webconnect webconnect-arrow-up-circle"></i>&nbsp;Upgrade
              </a>
            </ModalFooter>
          )}
        </Modal>
      </>
    );
  };

  render() {
    const { appSetting, actions, match } = this.props;
    const { projectId, version } = match.params;
    const { removeEnvironmentFromProjectPending, projectDetail, permissionFlags } = appSetting;
    if (!projectDetail) {
      return '';
    }
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }
    const deleteFlag = permissionsArray.includes(ENVIRONMENT);
    const { domainName, url, seoName } = projectDetail;
    let environments = projectDetail.environments || [];
    const upgrade = !['PAID_2', 'PAID_3'].includes(this.props.projectType);
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'environment'} projectDetail={projectDetail} />
        <ParentContentCard title="Environment" bgColor="drapcode-violet" icon="environment">
          <div className="app-setting-environment-setting">
            {this.showAddEnvironment()}
            {removeEnvironmentFromProjectPending ? (
              <CustomLoader loading={removeEnvironmentFromProjectPending} />
            ) : (
              <table className="table table-stripped table-hover table-bordered">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>URL</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {environments.map((environment) => (
                    <Environment
                      key={environment.uuid}
                      environment={environment}
                      domainName={domainName}
                      seoName={seoName}
                      upgrade={upgrade}
                      toggle={this.toggle}
                      deleteEnvironment={this.deleteEnvironment}
                      generateProjectEnvURL={this.generateProjectEnvURL}
                      updateEnvironmentProject={actions.updateEnvironmentProject}
                      projectId={projectId}
                      version={version}
                      deleteFlag={deleteFlag}
                      isReadOnly={isReadOnly}
                    />
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </ParentContentCard>
        <ParentDocCard>
          <h5>
            <b>About Environment</b>
          </h5>
          <p>
            DrapCode supports multiple environment based on which you can segregate the data and
            publish your application accordingly
          </p>
        </ParentDocCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EnvironmentSetting);
